interface IPosition {
  latitude: number;
  longitude: number;
}

function toRadians(value: number) {
  return value * (Math.PI / 180);
}

function getDistanceBetweenPointsKm(first: IPosition, second: IPosition) {
  const earthRadiusKm = 6371;
  const latitudeDelta = toRadians(second.latitude - first.latitude);
  const longitudeDelta = toRadians(second.longitude - first.longitude);
  const firstLatitude = toRadians(first.latitude);
  const secondLatitude = toRadians(second.latitude);
  const haversine = Math.sin(latitudeDelta / 2) ** 2
    + Math.cos(firstLatitude) * Math.cos(secondLatitude) * Math.sin(longitudeDelta / 2) ** 2;

  return 2 * earthRadiusKm * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
}

export function getGenderText(entry: any) {
  const sex = String(entry?.sex || '').toLowerCase();

  if (sex === 'f') {
    return 'Female';
  }
  else if (sex === 'm') {
    return 'Male'
  }
  return 'Unknown'
}

export function getTravelDistance(history: Array<IPosition> | null) {
  if (history === null) return 0;

  return history.reduce((p, c, idx) => {
    if (history.length === idx + 1) return p;
    return p + getDistanceBetweenPointsKm(c, history[idx+1]);
  }, 0)
}

export function getProtectedStatusText(status: any) {
  if (status === 'EX') return 'Extinct';
  if (status === 'EW') return 'Extinct in the Wild'
  if (status === 'CR') return 'Critically Endangered';
  if (status === 'EN') return 'Endangered';
  if (status === 'VU') return 'Vulnerable';
  if (status === 'NT') return 'Near Threatened';
  if (status === 'LC') return 'Least Concern';
  if (status === 'DD') return 'Data Deficient';
  if (status === 'NE') return 'Not Evaluated'
  return 'Unknown'
}